// Audit logging utility for tracking admin actions
import { supabase } from "@/integrations/supabase/client";

interface AuditLogEntry {
  action: string;
  resource: string;
  resource_id?: string;
  user_id?: string;
  details?: Record<string, any>;
}

const isDev = import.meta.env.DEV;

export const logAuditEvent = async (entry: AuditLogEntry) => {
  try {
    const { error } = await supabase
      .from('audit_logs')
      .insert({
        action: entry.action,
        resource: entry.resource,
        resource_id: entry.resource_id,
        user_id: entry.user_id,
        details: entry.details || {},
      });

    if (error) {
      if (isDev) console.error('Failed to store audit log in database:', error);
      try {
        const existingLogs = localStorage.getItem('audit_logs_fallback');
        const logs = existingLogs ? JSON.parse(existingLogs) : [];
        logs.push({ ...entry, timestamp: new Date().toISOString() });
        if (logs.length > 50) logs.shift();
        localStorage.setItem('audit_logs_fallback', JSON.stringify(logs));
      } catch (e) {
        if (isDev) console.error('Failed to store audit log in localStorage:', e);
      }
    }
  } catch (error) {
    if (isDev) console.error('Failed to log audit event:', error);
  }

  return entry;
};

export const logAuthAttempt = (success: boolean, email: string, reason?: string) => {
  return logAuditEvent({
    action: success ? 'auth_success' : 'auth_failed',
    resource: 'authentication',
    details: { email, reason },
  });
};

export const logSessionTimeout = (userId: string) => {
  return logAuditEvent({
    action: 'session_timeout_warning',
    resource: 'authentication',
    user_id: userId,
  });
};
